import { ReactNode } from 'react';
import ComponentPortal from './ComponentPortal';
import { ChakraBox } from '@equip.health/ui';

interface PageProps {
  children: ReactNode;
}

const Page = ({ children }: PageProps) => {
  return (
    <ChakraBox height="100%" overflow="hidden" position="relative" width="100%">
      {children}
      <ComponentPortal />
    </ChakraBox>
  );
};
export default Page;
